import * as types from '../../actions/types';

const initialState = false;

export default function isLoading (state = initialState, action) {
  switch (action.type) {
    
    case types.COMPLEX_TOPICS_DISCIPLINES_FETCH_STARTED:
    case types.FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_START:
      return true
    
    case types.COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED:
    case types.COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED:
    case types.FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED:
    case types.FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED:
      return false
    
    default:
      return state;
  }
}
